import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAccountLogo } from '~/store';

const DEFAULT_LOGO = '/sl_logo_name_v2_light.png';

export default function HeaderLogo() {
  const accountLogo = useSelector(selectAccountLogo);

  return (
    <Link to="/dashboard" id="qaidLogoHeaderLink" className="header-logo-container">
      <img src={accountLogo || DEFAULT_LOGO} className="header-logo" alt="logo" />
    </Link>
  );
}
